import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import Breadcrumb from '../../component/Breadcrumb';
import PageTabing from '../../component/PageTabing';
//import ModbusForm from './ModbusForm';
import { modbusOptions } from '../../constants';
import { fetchAutoCompleteSheetData, getExistingAddresses } from '../../api/mappingApi';
import swal from 'sweetalert';
import ModbusAddModal from './ModbusAddModal';
import ModbusForm from './ModbusForm';
import Loader from '../../component/Loader/Loader';

const ModBus = () => {

    const inputRef  = useRef(null);
    const [rowIndex, setRowIndex]                 = React.useState('');
    const [open, setOpen]                         = React.useState(false);
    const [showLoader, setShowLoader]             = React.useState(false);
    const [sheetMappingData, setSheetMappingData] = React.useState([]);
    const [sheetFilter, setSheetFilter]     = React.useState('');
    const [searchValue, setSearchValue]     = React.useState('');
    const [autoCompleteLoading, setAutoCompleteLoading] = React.useState(false);
    const [fieldsModal, setFieldsModal] = React.useState({
        RegAddr        :    '',
        Sheet          :    '',
        Addr           :    '',
        DataType       :    '',
        EnglishText    :    '',
    });
    const [fields, setFields] = React.useState([]);
    //const [updatedAddressData, setUpdatedAddressData] = React.useState(true);

    useEffect(() => {
        getFetchFieldsData();
    },[]);

    const getFetchFieldsData = async () => {
        let existingModbus= JSON.parse(localStorage.getItem('Modbus'));
        if(existingModbus != null && existingModbus.length > 0){
            setShowLoader(true);
            let fetchDataForExisiting = await getExistingAddresses(existingModbus);
            
            setShowLoader(false);
            if(fetchDataForExisiting){
                setFields(fetchDataForExisiting);
            }
        }
    }

    useEffect(() => {
        const fetchAutoCompleteData = () => {
            if(searchValue === ''){
                setSheetMappingData([]);
                return;
            }
            let active;
            if(sheetFilter && fieldsModal.RegAddr !== ''){
                active = true;
                ( async () => {
                        setAutoCompleteLoading(true);
                        const data = await fetchAutoCompleteSheetData(fieldsModal.RegAddr,sheetFilter,searchValue);
                        if(active){
                            setSheetMappingData(data);
                            setAutoCompleteLoading(false);
                        }
                    }
                )();
            }
            return () => {
                active = false;
            }
        };
        fetchAutoCompleteData();
    },[sheetFilter,searchValue,fieldsModal.RegAddr])

    const handleChangeAutoComplete = (values) => {
        if(values) {
            Object?.keys(values)?.map(val => {
                let key = val === 'Address' ? 'Addr' : val;
                return setFieldsModal((prevState) =>  ({...prevState, [key]: values[val] }))
            })
        }
    }

    const handleSearchValueAutoComplete = (value) => {
        setSearchValue(value);
    }

    const changeHandler = (name,value) => {
        if(name === 'Sheet'){
            setSheetFilter(value)
        }
        setFieldsModal((prevState) =>  ({...prevState, [name]: value }));
    };

    const handleDeleteInput = (index) => {
        const newArray = [...fields];
        newArray.splice(index, 1);
        setFields(newArray);
        let existingModbus= JSON.parse(localStorage.getItem('Modbus'));
        if(existingModbus != null && existingModbus.length > 0 && fields.length === 1){
            localStorage.removeItem("Modbus");
        }
    };


    const handleAddModalFormData = () => {
        let error = (fieldsModal.RegAddr === '' ||  fieldsModal.Sheet === '' || fieldsModal.Addr === '') ? true : false;
        if(error){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }

        if((fieldsModal.RegAddr >= 1 && fieldsModal.RegAddr <= 9999) && (fieldsModal.DataType.toLowerCase() !== 'boolean' && fieldsModal.DataType !== 'YesNoBoolean' && fieldsModal.DataType !== 'ActiveInactiveBoolean' &&  fieldsModal.DataType !== 'OnOffBoolean')){
            swal("Oops!", "Incorrect DataType selected for the Range. Please select address with Boolean Datatype.", "error");
            return false;
        }

        if((fieldsModal.RegAddr >= 40001 && fieldsModal.RegAddr <= 49999) && (fieldsModal.DataType === 'Boolean' || fieldsModal.DataType === 'YesNoBoolean' || fieldsModal.DataType === 'ActiveInactiveBoolean' || fieldsModal.DataType === 'OnOffBoolean')){
            swal("Oops!", "Incorrect DataType selected for the Range. Please select address without Boolean Datatype.", "error");
            return false;
        }

        let duplicateRegAddr;
        if(rowIndex !== ''){
            duplicateRegAddr =  fields.some((val,k) => val.RegAddr == fieldsModal.RegAddr && k != rowIndex  ? true : false);
        } else {
            duplicateRegAddr =  fields.some(val => val.RegAddr == fieldsModal.RegAddr ? true : false);
        }
        if(duplicateRegAddr){
            swal("Oops!", "Modbus Address is already used. Please select different Modbus Address.", "error");
            return false;
        }
        let duplicateAddr;
        if(rowIndex !== ''){
            duplicateAddr =  fields.some((val,k) => val.Addr == fieldsModal.Addr && k != rowIndex  ? true : false);
        } else {
            duplicateAddr =  fields.some(val => val.Addr == fieldsModal.Addr ? true : false);
        }
        if(duplicateAddr){
            swal("Oops!", "Address is already used. Please select different Address.", "error");
            return false;
        }

        if(rowIndex !== ''){
            const newArray = [...fields];
            newArray[rowIndex] = {...fields[rowIndex],...fieldsModal};
            setFields(newArray);
        } else {
            setFields(fields => [...fields, fieldsModal]);
        }
        setOpen(false);
    }


    const handleFormData = async () => {
        let error = false;
        //setUpdatedAddressData(false);
        fields.map((val) => (val.RegAddr === '' ||  val.Sheet === '' || val.Addr === '') ? error = true : error);
        if(error){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }
        let modbus = [];
        fields.map(item => {
            delete item.Sheet;
            delete item.EnglishText;
            delete item.DataType;
            let itemNew = {...item,RegAddr: parseInt(item.RegAddr)}
            return modbus.push(itemNew);
        });
        localStorage.setItem('Modbus',JSON.stringify(modbus));
        let existingModbus= JSON.parse(localStorage.getItem('Modbus'));
        if(existingModbus != null && existingModbus.length > 0){
            let exisitingModBusWithSheets = existingModbus.map(val => ({...val,Sheet:val?.Addr.substring(0,2).toLowerCase()}));
            setFields(exisitingModBusWithSheets);
        }
        swal({
            title: "Success",
            text: 'Modbus Address mapped successfully.',
            icon: "success",
        })
        getFetchFieldsData();
    }

    const handleClickOpen = () => {
        setOpen(true);
    };
  
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if(!open){
            setFieldsModal({
                RegAddr        :    '',
                Sheet          :    '',
                Addr           :    '',
                DataType       :    '',
                EnglishText    :    '',
            });
            setRowIndex('');
            setSheetFilter('');
            setSheetMappingData([]);
        }        
    },[open])

    const handleEditInput = (index,item) => {  
        setFieldsModal((prevState) =>  ({...prevState, 'RegAddr': item.RegAddr }));
        setRowIndex(index);
        setOpen(true);
    }


    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb  title="Modbus">
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb"> 
                Modbus
                </Typography>
            </Breadcrumb>
            <PageTabing value="modbus" />
            <Box  component="section">
                <Grid className="contentBox">
                    <Grid sx={{pr: '15px !important'}} className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                        <Grid item>
                            <Button
                                onClick={handleClickOpen}
                                variant="contained"
                                size="small"
                                color="primary"
                                sx={{mr:3}}
                            >Add New 
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                disabled={fields.length === 0 ? true : false}
                                onClick={handleFormData}
                                variant="contained"
                                size="small"
                                color="secondary"
                            >Submit
                            </Button>
                        </Grid>
                    </Grid>
                    {fields?.length > 0 && fields?.every(val => val.RegAddr !== '')  &&
                        <ModbusForm 
                            fields={fields}
                            handleEditInput={handleEditInput}
                            handleDeleteInput={handleDeleteInput}
                        />
                    }
                </Grid>
            </Box>
            <ModbusAddModal
                open={open}
                rowIndex={rowIndex}
                inputRef={inputRef}
                fields={fieldsModal} 
                onClose={handleClose}
                modbusOptions={modbusOptions}
                changeHandler={changeHandler} 
                handleDeleteInput={handleDeleteInput} 
                autoCompleteOptions={sheetMappingData}
                autoCompleteLoading={autoCompleteLoading}
                handleAddModalFormData={handleAddModalFormData}
                handleChangeAutoComplete={handleChangeAutoComplete}
                handleSearchValueAutoComplete={handleSearchValueAutoComplete}
            /> 
        </>
    );
};

export default ModBus;
